import React from 'react'
import PropTypes from 'prop-types'
import Alert from 'antd/lib/alert'
import 'antd/lib/alert/style/css'

import { IconComponent } from '..'

import './AlertComponent.scss'

const colorMap = {
  success: 'b7eb8f',
  info: '91d5ff',
  warning: 'fac546',
  error: 'ffa39e',
}

const augmentWithIcon = (opts) => {
  if (opts.icon) {
    return (
      <>
        <IconComponent
          name={opts.icon}
          size={[16, 16]}
          color={colorMap[opts.type]}
        />
        {opts.message}
      </>
    )
  }

  return opts.message
}

const shouldShowIcon = (opts) => {
  if (opts.icon) {
    return false
  }

  return opts.showIcon
}

const AlertComponent = (props) => {
  const content = augmentWithIcon(props)

  return (
    <div className="alert-component antd-component">
      <Alert {...props} message={content} showIcon={shouldShowIcon(props)} />
    </div>
  )
}

AlertComponent.propTypes = {
  icon: PropTypes.string,
}

export default AlertComponent
